<template>
  <div class="page">
    <div class="page__bd doc__wrp doc-only__wrp" @click="onDocClick($event)">
      <div v-html="article.contentHtml"></div>
    </div>
    <image-viewer ref="imageViewer" />
  </div>
</template>

<script>
import ImageViewer from "@/components/ImageViewer.vue";

export default {
  components: {
    ImageViewer
  },
  props: {
    projectCode: String,
    itemCode: String
  },
  data() {
    return {
      project: {
        items: [],
        homepage: null
      },
      article: {
        contentHtml: null
      }
    };
  },
  created() {
    var me = this;
    if (me.projectCode && me.itemCode) {
      me.getArticle(me.projectCode, me.itemCode);
    }
  },
  methods: {
    getArticle(projectCode, itemCode) {
      var me = this;
      me.$ajax({
        url: "/api/help/article/read",
        params: {
          projectCode,
          itemCode
        }
      }).then(function(res) {
        if (res.success) {
          me.article = res.data || {};
          me.$nextTick(function() {
            me.resizeImg();
          });
        }
      });
    },
    resizeImg() {
      // 适应文档最大宽度，等比例缩放图片
      var nodes = document.querySelectorAll(".doc__wrp img"),
        maxWidth = Math.min(document.body.clientWidth - 40, 880);
      nodes.forEach(node => {
        if (node.width > maxWidth) {
          node.style.zoom = maxWidth / node.width;
        } else {
          node.onload = function() {
            if (node.width > maxWidth) {
              node.style.zoom = maxWidth / node.width;
            }
          };
        }
      });
    },
    onDocClick(e) {
      var me = this,
        target = e.target;
      if (target.nodeName == "IMG") {
        me.$refs.imageViewer.setImage(target.src);
        e.preventDefault();
      }
    }
  }
};
</script>

<style scoped>
.doc__wrp.doc-only__wrp {
    padding: 20px;
    margin: 0 auto;
}
</style>